import $ from 'jquery';

$(document).ready(function () {
  if ($('.accordion').length >= 1) {
    $('.accordion-header').click(function (e) {
      e.preventDefault()

      $(this).toggleClass('opened')

      if ($(this).hasClass('opened')) {
        $(this).parent().find('.accordion-body').slideDown(150)
      } else {
        $(this).parent().find('.accordion-body').slideUp(150)
      }
    })
      let hash = window.location.hash;
      hash ? check4Anchor(hash) : null;
  }
})

function check4Anchor(anchor) {
    const checks = document.querySelectorAll('ul.anchor-check');
    if (checks.length > 0) {
        let targetId = anchor.substring(1);
        let anchorTarget = document.getElementById(targetId);
        if (anchorTarget) {
            if (anchorTarget.classList.contains('accordion-header')) {
                anchorTarget.click();
            }
        }
    }
}


